module.exports = __webpack_public_path__ + "img/WS.e9e3991b.svg";